import RegularGameIcon from "../assets/icons/regular-game-icon.svg";
import StandardGameIcon from "../assets/icons/standard-game-icon.svg";
import PremiumGameIcon from "../assets/icons/premium-game-icon.svg";
import GameIcon from "../assets/icons/game-icon.svg";
import FriendsIcon from "../assets/icons/friends-icon.svg";
import RulesIcon from "../assets/icons/rules-icon.svg";
import QuestIcon from "../assets/icons/quest-icon.svg";
import ProfileIcon from "../assets/icons/profile-icon.svg";
import FriendsGroupIcon from "../assets/icons/friends-group-icon.svg";
import InviteIcon from "../assets/icons/invite-icon.svg";
import EarningsIcon from "../assets/icons/earnings-icon.svg";
import Img_1 from "../assets/images/rules/img_1.svg";
import Img_2 from "../assets/images/rules/img_5.svg";
import Img_3 from "../assets/images/rules/img_8.svg";
import Img_4 from "../assets/images/rules/img_4.svg";
import Img_5 from "../assets/images/rules/img_9.svg";
import Img_6 from "../assets/images/rules/img_10.svg";
import Img_7 from "../assets/images/rules/img_11.svg";
import Img_8 from "../assets/images/rules/img_2.svg";
import Img_9 from "../assets/images/rules/img_7.svg";

export const gameCategoryCards = [
    {
        name: "Регулярная игра",
        subTitle: "Стоимость билета",
        icon: RegularGameIcon,
        level: 0,
        route: "regular-game"
    },
    {
        name: "Стандартная игра",
        subTitle: "Стоимость билета",
        icon: StandardGameIcon,
        level: 1,
        route: "standard-game"
    },
    {
        name: "Премиум игра",
        subTitle: "Стоимость билета",
        icon: PremiumGameIcon,
        level: 2,
        route: "premium-game"
    },
];



export const footerItems = [
    {
        name: "Игры",
        icon: GameIcon
    },
    {
        name: "Друзья",
        icon: FriendsIcon
    },
    {
        name: "Задания",
        icon: QuestIcon
    },
    {
        name: "Правила",
        icon: RulesIcon
    },

    {
        name: "Профиль",
        icon: ProfileIcon,
    },
]

export const AllTicketsCount = 777;

export const referralProgramInfo = [
    {
        icon: FriendsGroupIcon,
        name: "Мои друзья"
    },
    {
        icon: InviteIcon,
        name: "Приглашенных друзей"
    },
    {
        icon: EarningsIcon,
        name: "Заработок от друзей"
    },
]

export const rulesInfo = [
    {
        icon: Img_1,
        title: "Участие в лотерее",
        content_1: "Для участия необходимо зарегистрироваться через официальный смарт-контракт лотереи.",
        content_2: "Покупка билета осуществляется посредством перевода установленной суммы в криптовалюте на адрес смарт-контракта.",
        content_3: "Каждому участнику выдается уникальный идентификатор билета, который записывается в блокчейн.",
    },
    {
        icon: Img_2,
        title: "Стоимость билета",
        content_1: "Цена одного билета составляет фиксированную сумму, указанную в условиях лотереи.",
        content_2: "Покупка билетов возможна только в поддерживаемых криптовалютах.",
        content_3: "В случае изменения курса криптовалют, стоимость билета остается неизменной.",
    },
    {
        icon: Img_3,
        title: "Период проведения",
        content_1: "Продажа билетов начинается с момента активации смарт-контракта.",
        content_2: "Окончание продажи билетов и дата розыгрыша устанавливаются в условиях лотереи.",
        content_3: "Розыгрыш проводится автоматически после завершения продажи билетов.",
    },
    {
        icon: Img_4,
        title: "Прозрачность и честность",
        content_1: "Смарт-контракт лотереи полностью прозрачен и доступен для проверки в открытом блокчейне.",
        content_2: "Розыгрыш победителей осуществляется с использованием алгоритмов генерации случайных чисел, интегрированных в смарт-контракт.",
        content_3: "Все данные о билетах, участниках и результатах фиксируются в блокчейне и не подлежат изменению.",
    },
    {
        icon: Img_5,
        title: "Призовой фонд",
        content_1: "Призовой фонд формируется из средств, собранных от продажи билетов.",
        content_2: "Размер выигрышей и количество призовых мест указаны в условиях лотереи.",
        content_3: "Комиссия организаторов  автоматически вычитается из призового фонда и отображается в условиях лотереи.",
    },
    {
        icon: Img_6,
        title: "Определение победителей",
        content_1: "Победители определяются на основе алгоритма случайной выборки среди уникальных идентификаторов билетов.",
        content_2: "Результаты розыгрыша фиксируются в блокчейне и доступны для проверки.",
        content_3: "В случае отсутствия победителя по каким-либо техническим причинам, средства участников возвращаются автоматически.",
    },
    {
        icon: Img_7,
        title: "Выплата выигрышей",
        content_1: "Выигрыши автоматически перечисляются на адреса криптовалютных кошельков, с которых были куплены билеты.",
        content_2: "Участники несут ответственность за доступ к своему кошельку. В случае утери доступа организаторы не несут ответственности за невыданный выигрыш.",
    },
    {
        icon: Img_8,
        title: "Ограничения и ответственность",
        content_1: "Участие запрещено лицам, проживающим в юрисдикциях, где участие в лотереях запрещено законом.",
        content_2: "Организаторы не несут ответственности за технические сбои в сети блокчейна, влияющие на процесс лотереи.",
        content_3: "Участие в лотерее подразумевает согласие с указанными правилами.",
    },
    {
        icon: Img_9,
        title: "Прочие условия",
        content_1: "Организаторы оставляют за собой право изменять условия лотереи только до начала продажи билетов.",
        content_2: "Все изменения фиксируются в обновленной версии смарт-контракта, доступной для проверки.",
    },
];

export const FaqItems = [
    {
        title: "Как приобрести билет?",
        content: 'Откройте наш сайт и нажмите кнопку "Подключить кошелек".Поддерживаются популярные кошельки, такие как MetaMask, Trust Wallet .Выберите нужный уровень и количество билетов.Убедитесь, что у вас на кошельке достаточно средств в поддерживаемой криптовалюте (например USDT).Переведите указанную сумму на адрес смарт-контракта.После успешной транзакции вы получите уникальный идентификатор билета, записанный в блокчейн.'
    },
    {
        title: "Какая стоимость билета?",
        content: "Стоимость одного билета фиксирована и указана на странице текущего розыгрыша. Она оплачивается в поддерживаемой криптовалюте USDT, например: для WEB3 1 билет - 25 USDT Для ТГ Стартовый уровень «Майнинг Удачи»  1 билет - 1 USDT Стандарт уровень «Золотой Шанс»  1 билет - 5 USDT Премиум уровень «Крипто Сокровище»   1 билет - 10 USDT. Или другая актуальная цена билета, установленный для конкретного раунда. Убедитесь, что на вашем кошельке достаточно средств, чтобы оплатить билет и покрыть возможные транзакционные комиссии."
    },
    {
        title: "Сколько я могу приобрести билетов?",
        content: "Количество билетов, которые вы можете приобрести, не ограничено. Вы можете покупать столько билетов, сколько пожелаете, что увеличивает ваши шансы на выигрыш.Однако убедитесь, что вы соблюдаете условия и правила участия, указанные для конкретного розыгрыша."
    },
    {
        title: "Как часто происходит розыгрыш?",
        content: "Как только наши участники приобретут 777 билетов, мы немедленно объявим победителей."
    },
    {
        title: "Как распределяются выигрыш?",
        content: "Джекпот:  - 100* Х (х-стоимость билета), 125 выигрышей - 1*Х (х-стоимость билета), 62 выигрыша - 2*Х (х-стоимость билета), 16 выигрышей - 4*Х (х-стоимость билета)"
    },
    {
        title: "Как выиграть Джекпот?",
        content: "Для выигрыша Джекпота, участнику необходимо купить билет и его номер должен совпасть с определенным выигрышными номером, который выбирается случайным образом при каждом розыгрыше. Частота Розыгрышей Джекпота: Джекпот разыгрывается после продажи каждых 777 билетов."
    },
    {
        title: "Как выиграть Мегаджекпот?",
        content: "С каждого розыгрыша 3% от общей суммы взносов отправляются на специальный счет Мега Джекпота. Растущий Выигрыш: В течение 30 дней мы аккумулируем средства на счете Мега Джекпота. По истечении 30 дней наступает самое ожидаемое мгновение - Грандиозный Розыгрыш Мега Джекпота!"
    },
    {
        title: "Какое реферальное вознаграждение?",
        content: "Каждый участник, который привлекает нового игрока, получает 5% от суммы покупки одного билета  за каждый привлеченный билет. Активный приглашающий участник - это тот, кто продал не менее 5 билетов,получает 10 %  от суммы покупки. Реферальные уровни: На первом уровне каждый участник получает 10% от выигрыша каждого приведенного другом участника. На втором уровне каждый участник получает 5% от выигрыша каждого участника, приглашенного его прямым рефералом.На третьем уровне каждый участник получает 2% от выигрыша каждого участника, приглашенного его прямым или косвенным рефералом на втором уровне."
    },
    {
        title: "Какие бонусы можно получить?",
        content: "Бонус за привлечение рефералов: Игрок получит дополнительный бонус в размере 5 USDT, за привлечение 10 рефералов. Бонус за продажу билетов: Игрок получит дополнительный бонус в размере 100 USDT, за продажу 50 билетов. Бонус за победу в лотерее: Игрок получит дополнительный бонус в размере 50 USDT, при выигрыше в 3 розыгрышах подряд. Бонус за участие в лотерее: Игрок может получить дополнительный бонус в размере 5 USDT ,если купит 10 билетов."
    },
];

export const touchItems = [
    {
        title: "Регулярная игра",
        subtitle: "билетов",
        icon: RegularGameIcon,
    },
    {
        title: "Стандартная игра",
        subtitle: "билетов",
        icon: StandardGameIcon,
    },
    {
        title: "Премиум игра",
        subtitle: "билетов",
        icon: PremiumGameIcon,
    },
];

export const generateArray = () => {
    let arr: any = []
    for (let i = 1; i < 778; i++) {
        let item = {
            ticket_number: i.toString(),
            is_active: Math.random() < 0.7
        }
        arr.push(item)
    }
    return arr
}